import PageProtectedLayout from '../../../../components/Page/PageProtectedLayout';
import MetabolicHealth from './MetabolicHealth';
import { useTranslation } from '../../../../language';



export default function MetabolicHealthWelcome() {

  const { t } = useTranslation();

return (

    <PageProtectedLayout
      
      headline={t('page_hl_metabolic_health')}
      headlineFontWeight={500}

      >

      <MetabolicHealth />   
      
    </PageProtectedLayout>

  );
}